export function productsAnalytics(state = [], action) {
  switch (action.type) {
    case "PRODUCTS_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.productsAnalytics;
    default:
      return state;
  }
}
